export default __webpack_public_path__ + "static/media/2.75a4f545.png";